angular
  .module("myApp")
  .controller("TemplatesManagerController", function ($scope, $q, Dialog, Upload, TemplateFileUpload) {
    $scope.view = "templates_list"

    this.reload = () => $scope.$broadcast("reload")

    this.saveUploaded = (dto) => {
      const f = new TemplateFileUpload({
        id: dto.id,
        file_info_id: dto.file_info_id,
        nosaukums: dto.nosaukums,
        sablona_tips: dto.sablona_tips,
        ir_aktivs: dto.ir_aktivs,
      })
      return f.$save().then(this.reload)
    }

    this.openFile = (f) => {
      if (f === void 0) {
        f = {
          "new": true,
          ir_aktivs: true,
        }
      }
      return Dialog.dialog("pages/templates/template.form.html", f, {}, (p, action) => {
        if (action === "save") {
          if (p.file) {
            Upload.upload({
              url: "./upload",
              method: "POST",
              file: p.file,
            })
              .progress((evt) => {
                p.progress = {
                  loaded: evt.loaded,
                  total: evt.total,
                  percentage: $scope.percentize(evt.loaded, evt.total),
                }
              })
              .success((data) => {
                p.file_info_id = data.id
                return this.saveUploaded(p)
              })
              .error((data) => {
                p.loading = false
                if (data.indexOf("EntityStreamSizeException" > -1)) {
                  p.error = "Ielādējamais fails ir par lielu."
                } else {
                  p.error = data
                }
                return $q.reject(p.error)
              })
          } else {
            // izmanto jau esošo faila info
            p.file_info_id = p.file_info.id
            return this.saveUploaded(p)
          }
        }
      })
    }

    $scope.gridOptions = {
      // filtersUrl: 'pages/filter-text.html',
      defaultFilters: {},
      initialFilters: {},
      noDataLabel: "Nav atrasts neviens šablons.",
      rowClick: this.openFile,
      buttons: [
        {
          label: "Ielādēt jaunu šablonu",
          class: "btn-success",
          icon: "fa-plus",
          click: this.openFile,
        },
      ],
    }
  })
